import { render, staticRenderFns } from "./EditContactPopup.vue?vue&type=template&id=05bea5fe&scoped=true"
import script from "./EditContactPopup.vue?vue&type=script&lang=js"
export * from "./EditContactPopup.vue?vue&type=script&lang=js"
import style0 from "./EditContactPopup.vue?vue&type=style&index=0&id=05bea5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bea5fe",
  null
  
)

export default component.exports